import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  NavigationEnd,
  // NavigationStart,
  Router,
} from '@angular/router';
import { InnerPagesService } from '../../common-layout/inner-pages.service';
import { CommonService } from 'src/@services/common.service';
import {
  SESSION_STORAGE_PORT,
  StoragePort,
} from 'src/@shared/shared/providers';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: false,
})
export class PageNotFoundComponent implements OnInit {
  previousUrl: string = '';
  currentUrl: string = '';
  shouldRedirectToHome: boolean = false;

  constructor(
    public location: Location,
    private router: Router,
    private _iS: InnerPagesService,
    private _cS: CommonService,
    @Inject(SESSION_STORAGE_PORT) private sessionStoragePort: StoragePort
  ) {
    this.previousUrl = this.sessionStoragePort.getItem('currentURL') || '';
    this.currentUrl = this.router.url;

    // Listen to router events to track navigation
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  ngOnInit(): void {
    this.sessionStoragePort.setItem('currentURL', this.currentUrl);
    if (!this.previousUrl || this.previousUrl.includes('page-not-found')) {
      this.shouldRedirectToHome = true;
    } else {
      this.shouldRedirectToHome = false;
    }
  }
  canAccessSummary: boolean = false;
  redirectToHome() {
    const siteId = JSON.parse(
      this.sessionStoragePort.getItem('SiteDetails') || '{}'
    )?._id;
    if (siteId) {
      this.router.navigate([
        '/' + this._iS.getPermissionBasedLandingRoute(siteId),
      ]);
    } else {
      this.router.navigate(['/switch-account']);
    }
  }
  backToLastPage() {
    this.router.navigate([this.previousUrl]);
  }
}
